import type { IssueFieldQuestionMap } from "services/issues/issuesStore";

export enum InitQuestions {
  Name = "COMPANY_NAME",
  SameDayRegistration = "COMPANY_SAME_DAY_REGISTRATION",
}

export const ISSUE_FIELD_TO_QUESTION: IssueFieldQuestionMap<InitQuestions> = {
  company_name: InitQuestions.Name,
  name_postfix: InitQuestions.Name,
};

export const QUESTION_TO_PATH: Record<InitQuestions, string> = {
  [InitQuestions.Name]: "name",
  [InitQuestions.SameDayRegistration]: "same-day-registration",
};
